/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/* eslint-disable @typescript-eslint/consistent-type-assertions */

/**
 * Provider identity
 *
 * @public
 */
export interface ProviderIdentity {
  /**
   * id of the project
   */
  id: string;

  /**
   * Third party identity provider
   */
  provider: ProviderIdentityProvider;

  /**
   * Name of the user
   */
  name: string;

  /**
   * Username of the account
   */
  username?: string;

  /**
   * Email of the account
   */
  email: string;

  /**
   * URL of the users avatar
   */
  avatarUrl?: string;
}

export enum ProviderIdentityProvider {
  GOOGLE = <any>'GOOGLE',
  GITHUB = <any>'GITHUB',
}
